/**
 * 申請変更区分
 */
// tslint:disable-next-line:no-namespace
export namespace ApplicationChangeType {
    /** 変更 */
    export const CHANGE = '1';
    /** 継続 */
    export const CONTINUED = '2';
    /** 許可換え */
    export const PERMISSION_CHANGE = '3';
    /** 削除 */
    export const DELETE = '4';
}
